// @flow

import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { CSSTransition } from 'react-transition-group';
import PuzzlePiece from './PuzzlePiece';
import DnDTypes from './types';
import type { PieceData } from './types';

type Props = {
  pieceData: PieceData,
  connectDragSource: (React$Element<any>) => React$Element<any>,
  connectDragPreview: Function,
  isDragging: () => boolean,
  in: boolean,
  fieldWidth: number,
};

type State = {
  initialPosition: {
    width: string,
    height: string,
    position: string,
    marginLeft: string,
    marginTop: string,
  },
};

type CollectData = {
  connectDragSource: Function,
  connectDragPreview: Function,
  isDragging: boolean,
};

type DragData = {
  pieceNumber: number,
  pieceData: PieceData,
};

const draggableSource = {
  beginDrag(props: Props): DragData {
    return {
      pieceNumber: props.pieceData.number,
      pieceData: props.pieceData,
    };
  },
};

function collect(connect: any, monitor: any): CollectData {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

class DraggablePiece extends Component<Props, State> {
  componentDidMount(): void {
    this.props.connectDragPreview({
      captureDraggingState: true,
    });
  }

  render(): React$Element<any> {
    const { pieceData, connectDragSource, isDragging, fieldWidth } = this.props;
    const inProp = this.props.in;

    // eslint-disable-next-line
    const internetExplorer = /*@cc_on!@*/ false || !!document.documentMode;
    const draggableStyle = {
      opacity: isDragging && !internetExplorer ? 0 : 1,
    };

    return connectDragSource(
      <div className="puzzle__draggable-piece" style={draggableStyle}>
        <CSSTransition
          classNames="puzzle__drag-transition"
          in={inProp}
          timeout={300}
          key={pieceData.number}
        >
          <PuzzlePiece
            pieceData={pieceData}
            fieldWidth={fieldWidth}
            finished={true}
            prefix="drag"
          />
        </CSSTransition>
      </div>,
    );
  }
}

export default DragSource(DnDTypes.DRAGGABLE_PIECE, draggableSource, collect)(
  DraggablePiece,
);
